module.exports = __webpack_public_path__ + "img/logo_seremonia.8c819d8c.png";